/* Restock countdown je Variante + Benachrichtigung ueber Klaviyo (Back in Stock).
   Der Block ist fuer alle Varianten vorbereitet (data-restock-map: Variant-ID -> [verfuegbar 1/0, Frist als Unix-Zeit oder 0]).
   Je nach gewaehlter Variante zeigt dieses Skript den Countdown (72h nach out_of_stock_since), den Hinweis ohne Termin
   (ausverkauft ohne Zeitstempel) oder nichts (Variante verfuegbar). Nach Ablauf der Frist steht "Kuerze".
   Die Anzeige wird alle 200 ms geprueft und nach jedem Klick sofort aktualisiert, damit ein Variantenwechsel ohne Verzoegerung wirkt.
   Ist keine Variante gewaehlt bzw. findbar (z. B. komplett ausverkauftes Produkt), gilt die erste Variante der Liste.
   Das Formular im Dialog "Benachrichtige mich" meldet die E-Mail-Adresse fuer die gewaehlte Variante bei Klaviyo an
   (Client-API back-in-stock-subscriptions, Variant-ID im Format $shopify:::$default:::<ID>).
   Schlaegt das fehl, wird das normale Kontaktformular abgeschickt (Fallback).
   Das Theme (popup-component) bindet nur das ERSTE [data-popup-open] im Block. Die beiden Hinweistexte haben je einen Link;
   der sichtbare wird deshalb auf das erste Element weitergeleitet. */
(function () {
  var KLAVIYO_COMPANY_ID = 'YiBz8t';
  var KLAVIYO_REVISION = '2024-10-15';
  var lastRoot = null;

  function formatRemaining(seconds) {
    if (seconds <= 0) return null;

    var days = Math.floor(seconds / 86400);
    var hours = Math.floor((seconds % 86400) / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);

    if (days > 0) {
      var daysLabel = days === 1 ? ' Tag' : ' Tagen';
      var hoursLabel = hours === 1 ? ' Stunde' : ' Stunden';
      return days + daysLabel + (hours > 0 ? ', ' + hours + hoursLabel : '');
    }

    if (hours > 0) {
      var hLabel = hours === 1 ? ' Stunde' : ' Stunden';
      var mLabel = minutes === 1 ? ' Minute' : ' Minuten';
      return hours + hLabel + (minutes > 0 ? ', ' + minutes + mLabel : '');
    }

    var minLabel = minutes === 1 ? ' Minute' : ' Minuten';
    return Math.max(minutes, 1) + minLabel;
  }

  function mapOf(root) {
    var map = root.__restockMap;
    if (!map) {
      try { map = JSON.parse(root.getAttribute('data-restock-map') || '{}'); } catch (e) { map = {}; }
      root.__restockMap = map;
    }
    return map;
  }

  function variantIdOf(root, map) {
    var form = root.closest('form');
    var el = form && form.querySelector('[name="id"]');
    var v = el && el.value;
    if (!v || !map[String(v)]) {
      v = '';
      try { v = new URLSearchParams(window.location.search).get('variant') || ''; } catch (e) {}
    }
    if (!v || !map[String(v)]) {
      var keys = Object.keys(map);
      v = keys.length ? keys[0] : '';
    }
    return v ? String(v) : '';
  }

  function update(root) {
    var map = mapOf(root);
    var block = root.querySelector('.restock-countdown');
    var timeEl = root.querySelector('[data-restock-time]');
    var btn = root.querySelector('.restock-notify-btn');
    var info = map[variantIdOf(root, map)];
    var out = !!info && info[0] === 0;
    var deadline = out ? info[1] : 0;

    if (block) block.style.display = (out && deadline > 0) ? '' : 'none';
    if (btn) btn.style.display = (out && !(deadline > 0)) ? '' : 'none';

    if (out && deadline > 0 && timeEl) {
      var text = formatRemaining(deadline - Math.floor(Date.now() / 1000));
      timeEl.textContent = text === null ? 'Kürze' : text;
    }
  }

  function tick() {
    var roots = document.querySelectorAll('[data-restock-map]');
    for (var i = 0; i < roots.length; i++) update(roots[i]);
  }

  function showMessage(form, text, isError) {
    var box = form.querySelector('.restock-klaviyo-message');
    if (!box) {
      box = document.createElement('p');
      box.className = 'restock-klaviyo-message';
      box.style.cssText = 'margin-top:12px; font-size:0.9em; line-height:1.45;';
      form.appendChild(box);
    }
    box.style.color = isError ? '#9b2c2c' : '#2b2b28';
    box.textContent = text;
  }

  function subscribe(form) {
    var root = form.closest('[data-restock-map]') || lastRoot;
    if (!root) return Promise.reject(new Error('no root'));
    var map = mapOf(root);
    var variantId = variantIdOf(root, map);
    var emailEl = form.querySelector('input[type="email"]');
    var email = emailEl && emailEl.value && emailEl.value.trim();
    if (!variantId || !email) return Promise.reject(new Error('missing data'));

    var body = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!(res.status >= 200 && res.status < 300)) throw new Error('klaviyo ' + res.status);
      return true;
    });
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-notification-form]')) return;
    if (!(form.closest('[data-restock-map]') || lastRoot)) return;
    if (form.__klaviyoDone) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (form.__klaviyoFallback) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    subscribe(form).then(function () {
      form.__klaviyoDone = true;
      var fields = form.querySelector('.product__notification__form');
      if (fields) fields.style.display = 'none';
      showMessage(form, 'Danke! Wir schreiben Dir einmalig, sobald es wieder verfügbar ist.', false);
    }).catch(function () {
      /* Fallback: normales Kontaktformular (Anfrage geht per E-Mail an uns) */
      form.__klaviyoFallback = true;
      if (submitBtn) submitBtn.disabled = false;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
    });
  }

  function onClick(e) {
    var t = e.target;
    var r = t && t.closest ? t.closest('[data-restock-map]') : null;
    if (r) {
      lastRoot = r;
      var opener = t.closest('[data-popup-open]');
      var first = r.querySelector('[data-popup-open]');
      if (opener && first && opener !== first) {
        /* Das Theme hat nur das erste Oeffnen-Element gebunden: Klick dorthin weiterleiten. */
        e.preventDefault();
        e.stopImmediatePropagation();
        first.click();
      }
    }
    tick();
    setTimeout(tick, 50);
    setTimeout(tick, 150);
  }

  function init() {
    tick();
    setInterval(tick, 200);
    document.addEventListener('click', onClick, true);
    document.addEventListener('submit', onSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();